import React from "react";
import { Link } from "react-router-dom";
import { Globe, Settings } from "lucide-react";
import { AnnouncementBell } from "../AnnouncementBell";

/**
 * Sticky-style brand + language cycler + settings entry point used
 * exclusively at the top of the citizen home screen.
 */
export const HomeHeader = ({ tagline, currentLang, onCycleLang }) => (
  <header
    className="relative z-10 flex items-center justify-between px-5 pt-3 pb-2.5 bg-background/85 backdrop-blur-xl"
    data-testid="home-header"
  >
    <div className="flex items-center gap-2.5 min-w-0">
      <span
        aria-hidden
        className="relative w-9 h-9 rounded-xl shadow-md overflow-hidden flex shrink-0 ring-1 ring-black/5 dark:ring-white/10"
      >
        <span className="flex-1 bg-mali-green" />
        <span className="flex-1 bg-mali-yellow" />
        <span className="flex-1 bg-mali-red" />
      </span>
      <div className="min-w-0">
        <h1
          className="font-display text-[17px] font-black tracking-tight leading-none text-mali-navy dark:text-white flex items-baseline gap-1.5"
          data-testid="brand-title"
        >
          <span className="text-mali-red">SOS</span>
          <span>MALI</span>
        </h1>
        <p className="text-[10px] font-medium tracking-wide text-muted-foreground leading-none mt-1">
          {tagline}
        </p>
      </div>
    </div>
    <div className="flex items-center gap-0.5 shrink-0">
      <AnnouncementBell />
      <button
        type="button"
        onClick={onCycleLang}
        data-testid="lang-cycle-btn"
        className="px-2 py-1.5 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
        aria-label="Changer la langue"
      >
        <Globe className="w-4 h-4" />
        <span className="text-[10px] font-bold uppercase">{currentLang}</span>
      </button>
      <Link
        to="/settings"
        data-testid="settings-link"
        className="p-2 rounded-lg hover:bg-muted text-muted-foreground hover:text-foreground transition-colors"
        aria-label="Réglages"
      >
        <Settings className="w-4 h-4" />
      </Link>
    </div>
  </header>
);
